

<div class="card">
  <div class="card-content">

    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalCount }}</span>
          <span class="stats-card-label">Total Contracts</span>
          <span class="stats-card-sublabel">Showing</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-file"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ expiringInYearCount }}</span>
          <span class="stats-card-label">Expiring {{ selectedYear }}</span>
          <span class="stats-card-sublabel">This year</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-calendar-times"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ msaCount }}</span>
          <span class="stats-card-label">MSA</span>
          <span class="stats-card-sublabel">Master agreements</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-briefcase"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ sowCount }}</span>
          <span class="stats-card-label">SOW</span>
          <span class="stats-card-sublabel">Statements of work</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-square"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ proposalCount }}</span>
          <span class="stats-card-label">Proposals</span>
          <span class="stats-card-sublabel">Active proposals</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-send"></i></div>
      </div>
    </div>

    <div class="summary-grid-container" *ngIf="!loading">
      <p-table
        [value]="filteredRows"
        styleClass="p-datatable no-column-lines compact-striped-table table-no-xscroll"
        [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
        [scrollable]="true"
        scrollHeight="flex"
        [paginator]="false">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="customerName" class="col-customer">Customer Name <p-sortIcon field="customerName" /></th>
            <th pSortableColumn="projectName" class="col-project">Project Name <p-sortIcon field="projectName" /></th>
            <th pSortableColumn="type" class="col-type">Type <p-sortIcon field="type" /></th>
            <th *ngFor="let month of months"
                class="month-header col-month">
              {{ month.label }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td class="customer-cell"><strong>{{ row.customerName }}</strong></td>
            <td class="project-cell">{{ row.projectName }}</td>
            <td>
              <p-tag [value]="row.type" [severity]="getTypeSeverity(row.type)" />
            </td>
            <td *ngFor="let month of months"
                class="month-cell text-center"
                [class.expiry-month]="isExpiryMonth(row, month.value)"
                (click)="openExpiryDialog(row, month.value)"
                [pTooltip]="getMonthCellTooltip(row, month.value)">
              <span *ngIf="isExpiryMonth(row, month.value)" class="expiry-indicator">Exp</span>
              <span *ngIf="!isExpiryMonth(row, month.value)" class="no-data">—</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr class="table-empty-row">
            <td [attr.colspan]="15" class="table-empty-cell">
              <div class="empty-state">
                <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                <p class="empty-message">No contracts found</p>
                <p class="empty-description">Try changing the year in the header or search text</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="loading" class="loading-container loading-container--centered">
      <i class="pi pi-spin pi-spinner loading-spinner-icon"></i>
      <p>Loading contracts...</p>
    </div>
  </div>
</div>

<!-- Calendar popup (like Invoice Planning Grid) -->
<p-dialog
  [header]="'Contract Expiry - ' + getCalendarMonthName() + ' ' + dialogYear"
  [(visible)]="showExpiryDialog"
  [modal]="true"
  [style]="{ width: 'auto', maxWidth: '520px', minWidth: '480px' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="closeExpiryDialog()"
  styleClass="calendar-dialog"
  [contentStyle]="{ 'overflow': 'visible', 'padding': '0' }">
  <div class="calendar-dialog-content compact">
    <div class="calendar-navigation mb-3">
      <p-button
        icon="pi pi-chevron-left"
        (onClick)="navigateCalendarMonth(-1)"
        [text]="true"
        severity="secondary"
        [pTooltip]="'Previous Month'"
        size="small" />
      <span class="calendar-month-year">{{ getCalendarMonthName() }} {{ dialogYear }}</span>
      <p-button
        icon="pi pi-chevron-right"
        (onClick)="navigateCalendarMonth(1)"
        [text]="true"
        severity="secondary"
        [pTooltip]="'Next Month'"
        size="small" />
    </div>
    <div class="calendar-grid compact">
      <div class="calendar-header compact">
        <div class="calendar-day-header compact" *ngFor="let dayName of ['S', 'M', 'T', 'W', 'T', 'F', 'S']">
          {{ dayName }}
        </div>
      </div>
      <div class="calendar-body compact">
        <div
          class="calendar-day compact"
          [class.empty]="day.day === 0"
          [class.expiry-day]="day.isExpiryDay"
          [class.weekend]="day.day > 0 && isWeekend(day.date)"
          *ngFor="let day of calendarDays">
          <div class="day-number compact" *ngIf="day.day > 0">{{ day.day }}</div>
          <div class="expiry-label compact" *ngIf="day.isExpiryDay">Exp</div>
        </div>
      </div>
    </div>
    <p *ngIf="dialogRow" class="expiry-date-line mt-3 mb-0">
      <strong>Expiry:</strong> {{ getDialogExpiryDateFormatted() }} · {{ dialogRow.customerName }} · {{ dialogRow.projectName }} · {{ dialogRow.type }}
    </p>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" (onClick)="closeExpiryDialog()" severity="secondary" />
  </ng-template>
</p-dialog>
